import { UserPreferencesApi } from 'core/utils/types/user-custom-filter.type';

import { SaveUserPreferencesViewConfigAPI, UserPreferencesViewConfigAPI } from '../api';
import { EditableColumn } from '../model';
import { UserPreferencesViewConfig, UserPreferencesViewConfigFlat } from '../model/user-preferences-view-fields.model';
import { mapEditableColumnFromAPIToModel, mapEditableColumnFromModelToAPI } from './editable-column.mapper';

export const mapUserPreferencesViewConfigFromAPIToModel = (
    userPreferences: UserPreferencesApi | UserPreferencesViewConfigAPI
): UserPreferencesViewConfig => ({
    userPreferencesId: userPreferences.userPreferencesId,
    viewFields: userPreferences.viewFields.map((viewData) => ({
        viewFieldId: viewData.viewFieldId,
        viewType: viewData.viewType,
        viewId: viewData.viewId,
        fields: viewData.fields.map(mapEditableColumnFromAPIToModel),
    })),
});

export const mapUserPreferencesViewConfig = (
    userPreferences: UserPreferencesViewConfig,
    viewType: string,
    viewId?: string
): UserPreferencesViewConfigFlat => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const viewData = userPreferences?.viewFields?.find(
        (viewField) => viewField.viewType === viewType && (viewId ? viewField.viewFieldId === viewId : true)
    )!;

    if (!viewData) {
        // eslint-disable-next-line no-console
        console.warn(`No view data found for type: ${viewType} and id: ${viewId}`);
    }
    return {
        userPreferencesId: userPreferences.userPreferencesId,
        viewFieldId: viewData?.viewFieldId,
        viewType: viewData?.viewType,
        viewId: viewData?.viewId,
        fields: viewData?.fields.map(mapUserPreferencesViewFieldsField) || [],
    };
};

export const mapUserPreferencesViewConfigFromModelToAPI = (
    userPreferences: UserPreferencesViewConfigFlat
): SaveUserPreferencesViewConfigAPI => ({
    userPreferencesId: userPreferences.userPreferencesId,
    viewFieldId: userPreferences.viewFieldId,
    viewType: userPreferences.viewType,
    viewId: userPreferences.viewId,
    fields: userPreferences.fields.map(mapEditableColumnFromModelToAPI),
});

const mapUserPreferencesViewFieldsField = (field: EditableColumn): EditableColumn => ({
    fieldId: field.fieldId,
    field: field.field,
    text: field.text ?? undefined,
    visible: field.visible,
    pinned: field.pinned,
    disabled: field.disabled ?? undefined,
    columnIndex: field.columnIndex,
});
